import React, { memo } from 'react';
import ErrorBoundary from '../ErrorBoundary';
import CollectionsTree from './CollectionsTree';

export default memo(() => (
  <ErrorBoundary>
    <CollectionsTree />
  </ErrorBoundary>
));
